import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { firstValueFrom, Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class DocumentDownloadService {
    constructor(private readonly httpClient: HttpClient) {}

    downloadFileToBuffer(url: string): Observable<ArrayBuffer> {
        return this.httpClient.get(url, { responseType: 'arraybuffer' });
    }

    downloadFile(url: string, contentType: string) {
        this.downloadFileToBlobUrl(url, contentType).then((url) => {
            let pwa = window.open(url);
            if (!pwa || pwa.closed || typeof pwa.closed == 'undefined') {
                alert('Please disable your Pop-up blocker and try again.');
            }
        });
    }

    async downloadFileToBlobUrl(
        url: string,
        contentType: string
    ): Promise<string> {
        let data = await firstValueFrom(this.downloadFileToBuffer(url));
        let blob = new Blob([data], { type: contentType });
        return window.URL.createObjectURL(blob);
    }
}
